import { render, staticRenderFns } from "./DumbappWallet.vue?vue&type=template&id=31fd3cce&"
import script from "./DumbappWallet.vue?vue&type=script&lang=ts&"
export * from "./DumbappWallet.vue?vue&type=script&lang=ts&"
import style0 from "./DumbappWallet.vue?vue&type=style&index=0&id=31fd3cce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports